import { FUNCTIONS_URL, supabase } from './supabase';

export class ApiError extends Error {
  constructor(public status: number, message: string, public details?: unknown) {
    super(message);
  }
}

/** Appel d'Edge Function authentifié (expert) avec erreurs typées. */
export async function appelerFonction<T>(nom: string, corps: unknown): Promise<T> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new ApiError(401, 'Session expirée');
  return appeler<T>(nom, corps, { Authorization: `Bearer ${session.access_token}` });
}

/** Appel d'Edge Function par l'assuré (jeton du lien magique, pas de session Supabase). */
export async function appelerFonctionClient<T>(nom: string, jeton: string, corps: unknown): Promise<T> {
  return appeler<T>(nom, corps, { 'x-client-token': jeton });
}

/** Edge Function publique (connexion de l'assuré par e-mail + n° de dossier). */
export async function appelerFonctionPublique<T>(nom: string, corps: unknown): Promise<T> {
  return appeler<T>(nom, corps, {});
}

async function appeler<T>(nom: string, corps: unknown, headers: Record<string, string>): Promise<T> {
  const res = await fetch(`${FUNCTIONS_URL}/${nom}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
      ...headers,
    },
    body: JSON.stringify(corps),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, data.error ?? `Erreur ${res.status}`, data.details);
  return data as T;
}
